import { EntityStore } from './entity-store'

type QuickKeyLayoutsStore = EntityStore<'quickKeyLayouts'>

/**
 * Stores information on the retailer's quickKeyLayouts.
 */
export const quickKeyLayoutsStore: QuickKeyLayoutsStore = new EntityStore({
  entityStoreName: 'quickKeyLayouts',
  entityName: 'button_layouts',
})
